<template>
  <div id="uid-suggestions">
    <xm-input name="uid" id="uid-input" v-model="val" label="Username" :error="uidErrorStr" :pattern="uidRegex" ref="uid" @blur="hideSuggestions(100)"></xm-input>
    <div class="uid-menu">
      <ul ref="dropdown" id="uid-dropdown" v-if="showDropdown">
        <li id="uid-taken-warning">That username is taken. Here are some suggestions</li>
        <li class="suggestion" v-for="item in uidSuggestions" @click="()=>{choose(item)}">{{item}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import helpers from '../../lib/helpers'
import req from '../../lib/authRequest'
import reg from '../../lib/regex'
import XmInput from '../XmInput.vue'
import validators from '../../lib/validators'

export default {
  name: "UsernameSuggest",
  components: {
    XmInput,
  },
  data(){
    return {
      val: '',
      uidSuggestions: [],
      unusedUid: undefined,
      uidRegex: reg.uid
    }
  },
  props:{
    value: {type: String},
    fname: {type: String},
    lname: {type: String},
  },
  created(){
    this.debouncedSuggestions = helpers.debounce(this.usernameSuggestions, 300)
  },
  mounted(){
    this.val = this.value
  },
  computed:{
    uidValidityDetails () {
      return validators.username(this.val);
    },
    uidValid(){
      return this.uidValidityDetails.valid;
    },
    uidErrorStr() {
      return this.uidValidityDetails.suggestion;
    },
    uid(){
      return this.$refs.uid.$refs.input
    },
    uidFormClasses(){
      return this.$refs.uid.$refs.form.classList
    },
    showDropdown(){
      return this.uidSuggestions.length > 0
    }
  },
  watch:{
    val(newval) {
      this.$emit('input', newval)
      this.$emit('form-state', this.uidValid);
      if (!this.uidValid){
        this.$refs.uid.$data.valid = false
      }
      this.debouncedSuggestions(newval)
    },
    uidSuggestions(newval) {
      // console.log('watching uidSuggestions ', newval)
    },
    showDropdown(newval) {
      if (newval) {
        this.uid.style.borderBottomLeftRadius = '0px'
        this.uid.style.borderBottomRightRadius = '0px'
      } else {
        this.uid.style.borderBottomLeftRadius = '4px'
        this.uid.style.borderBottomRightRadius = '4px'
      }
      // console.log('watching showDropdown ', newval)
    },
    canUse(){
      let rem
      let add
      if (this.uidValid && this.unusedUid){
        rem = ['has-error', 'has-warning']
        add = ['has-success']
      } else if (this.uidValid === false){
        rem = ['has-success', 'has-warning']
        add = ['has-error']
      } else if (this.unusedUid === false){
        rem = ['has-success', 'has-error']
        add = ['has-warning']
      }
      this.uidFormClasses.remove(rem)
      this.uidFormClasses.add(add)
    },
  },
  methods:{
    hideSuggestions(ms){
      let self = this
      setTimeout(()=>{
        self.uidSuggestions = []
      }, ms)
    },
    usernameSuggestions(uid) {
      let self = this
      if (!this.uidValid) return
      return req.get({
        url: req.param('/self_signup/usernames', {uid, name: `${self.fname} ${self.lname}`}),
        success(data) {
          self.uidSuggestions = data['suggestions']
          self.unusedUid = !data['in_use']
        },
        error(result) {
          self.unusedUid = true
          self.uidSuggestions = []
          // console.log('error getting username suggestions ', result)
        },
      })
    },
    choose(val){
      this.val = val
      //let val2 = val
      //let self = this
      //setTimeout(()=>{this.$set(this, 'val', val2)},100)
    }
  }
}
</script>

<style scoped>
#uid-input{
  padding-bottom: 0;
  margin-bottom: 0;
}
/* #uid-dropdown{
  position: absolute;
  background: white;
  z-index: 1000;
  border: #0d0d0d 1px solid;
  border-top: none;
  padding-top: 0;
  margin-top: 0;
  width: 95%;
  padding-left: 0;
  border-bottom-left-radius: 1em;
  border-bottom-right-radius: 1em;
} */

/* .suggestion{
  list-style-type: none;
  cursor: pointer;
  width: 100%;
  padding-top: 1%;
  padding-left: 5%;
} */

.suggestion {
  list-style-type: none;
  cursor: pointer;
  width: 100%;
  padding:2px 10px;
  font-size: 15px;
}

.suggestion:hover{
  background: #e6e6e6;
}
/* #uid-taken-warning{
  list-style-type: none;
  background: #959556;
  text-align: center;
} */


#uid-taken-warning {
  list-style-type: none;
  background: #B63A00;
  color: white;
  padding: 4px;
  font-size: 15px;
  text-align:center;
  margin-bottom: 4px;
  width: 100%;
}

#uid-dropdown {
  position: absolute;
  background: #fff;
  z-index: 1000;
  border: 1px solid #ccc;
  border-top: none;
  padding:0 0 4px 0;
  margin-top: 0;
  width: 100%;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.uid-menu {
  position: relative;
  width: 100%;
}



</style>



// WEBPACK FOOTER //
// UsernameSuggest.vue?b7c98a98